module.exports = __webpack_public_path__ + "3cc1ce3d2b7124093f688e62a52bdc58.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/taggy.png
 ** module id = 901
 ** module chunks = 9
 **/